import * as Yup from 'yup';

export const sponsorFormSchema = Yup.object().shape({
    sponsering_package: Yup.object().shape({
        title: Yup.string().required('تعداد پیام را مشخص کنید'),
        id: Yup.number(),
    }),
    type: Yup.object().shape({
        title: Yup.string().required('دسته آگهی را مشخص کنید'),
        id: Yup.string(),
    }),
    text: Yup.string()
        .min(5, 'متن باید حداقل 5 حرف باشد')
        .max(60, 'متن باید حداکثر 60 حرف باشد')
        .required('متن تبلیغی مورد نظرتان را وارد کنید'),
    link: Yup.string()
        .url('لینک صفحه تبلیغی معتبر وارد کنید')
        .required('لینک صفحه تبلیغی مورد نظرتان را وارد کنید'),
    state: Yup.array(),
    city: Yup.array(),
    water_system: Yup.array(),
    product: Yup.array(),
});